module.exports = __webpack_public_path__ + "img/ZGWLogo.a9ff69f1.png";